import axios from '@/axios'

class PostDataService {
  async getAllPosts(page: number): Promise<any> {
    return axios.get(`/posts/getAllPosts?page=${page}`)
  }
  async getPostById(id: any): Promise<any> {
    return axios.get(`/posts/${id}/get`)
  }

  async getPostBySlug(slug: string): Promise<any> {
    return axios.get(`/posts/slug/${slug}/get`)
  } async add(data: any): Promise<any> {
    return axios.post('/posts/create', data)
  } async uploadImage(id: any, data: any, fileName?: string): Promise<any> {
    const formData = new FormData()
    formData.append('image', data)
    // Backend requires a 'name' field for the image
    formData.append('name', fileName || data.name || `post_${id}_image_${Date.now()}`)
    return axios.post(`/posts/${id}/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  } async update(id: any, data: any): Promise<any> {
    return axios.put(`/posts/${id}/update`, data)
  } async delete(id: any): Promise<any> {
    return axios.delete(`/posts/${id}`)
  }
}
export default new PostDataService()